export enum AdminNotificationType {
  Push = 0,
  InApp = 1,
  Both = 2,
}
